import Vue from 'vue'
import Vuex from 'vuex'

// vuex store
import states from './states'
import mutations from './mutations'
import getters from './getters'

// modules
import toolsPanel from './modules/tools-panel'
import dashboardSettings from './modules/dashboard-settings'
import models from './modules/models'
import dataGrid from './modules/data-grid'
import comments from './modules/comments';
import actions from './actions'
import access from './modules/access'
import templateDash from './modules/template-dash'
import simpleWorkflow from './modules/simple-workflow'
import diagramBuilder from './modules/diagram-builder'

Vue.use(Vuex)

function initialState () {
  return states
}

// init store
export default new Vuex.Store({
  modules: {
    diagramBuilder
  },
  actions: {
    // mudules actions
    ...actions,
    ...models.dashboard.action,
    ...dataGrid.action,
    ...comments.action,
    ...simpleWorkflow.action,
  },
  state: {
    ...states,
    // modules state
    ...toolsPanel.state,
    ...dashboardSettings.state,
    ...models.dashboard.state,
    ...dataGrid.state,
    ...comments.state,
    ...access.state,
    ...templateDash.state,
    ...simpleWorkflow.state,
  },
  mutations: {
    reset (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    ...mutations,
    // modules mutations
    ...toolsPanel.mutation,
    ...dashboardSettings.mutation,
    ...models.dashboard.mutation,
    ...dataGrid.mutation,
    ...comments.mutation,
    ...access.mutation,
    ...templateDash.mutation,
    ...simpleWorkflow.mutation,
  },
  getters: {
    ...getters,
    ...dataGrid.getter,
    ...comments.getter,
  },
})
